export const DOCUMENT_DOWNLOAD = 'download_document';
export const SUPPORT_SUBMIT = 'support_submit';
export const INTERNAL_USER = 'Internal';
export const EXTERNAL_USER = 'External';
export const EMPLOYEE = 'Employee';
export const FIBI = 'fibi';

export const CUSTOMER = 'Customer';

export const BULK = 'bulk';

// For Analytics Purpose
export const PAGE_LOAD_EVENT = 'Page Loaded';
export const SUPPORT_EVENT = 'sendSupportAnalytics';
export const SUPPORT_START_EVENT = 'Process Start';
export const SUPPORT_COMPLETE_EVENT = 'Process Complete';
export const PROCESS_ERROR_EVENT = 'Process Error';
export const PROCESS_CANCEL_EVENT = 'Process Cancel';

export const SUPPORT_START_DESC = 'Support - Ask a Question form loads';
export const SUPPORT_COMPLETE_DESC = 'Support - Ask a Question success modal loads';
export const SUPPORT_PROCESS_ERROR_DESC = 'Suppor- Ask a Question form error';

export const SEARCH_RESULTS_EVENT = 'searchResult';
export const SEARCH_RESULTS_DISPLAYED = 'Search Results Displayed';

export const CLICK_EVENT = 'Click Action';
export const INTERNAL_SEARCH_CAPABILITY = 'Internal Search';

export const SELECTED_ITEMS_PER_PAGE_DESC = 'User selects ## of items per page';
export const SHOW_MORE_DESC = 'User clicks Show More Items';

export const USER_CHECKS_BOX = 'User checks box to view new column';
export const USER_UNCHECKS_BOX = 'User unchecks box to hide column';
export const ADD_DATA_COLUMN = 'Add Data Column: ##';
export const HIDE_DATA_COLUMN = 'Hide Data Column: ##';

export const CONTRACT_EVENT = 'sendContractAnalytics';
export const CONTRACT_TYPE = 'Contract';
export const CONTRACT_DOWNLOAD_DESC = 'Contracts - Download Contract';
export const CONTRACT_DOWNLOAD_EVENT = 'Document Download';
export const CONTRACT_FILTER_DESC = 'Contracts -  Filter Interaction';
export const CONTRACT_FILTER_EVENT = 'Filters Applied';
export const CONTRACT_VIEW_CONTRACT_DESCP = 'Contracts - View Contract';
export const CONTRACT_VIEW_CONTRACT_EVENT = 'Document View';
export const CONTRACT_DOWNLOAD_MODAL_OPEN_DESC = 'Contracts - Download Contract Modal - Click';
export const CONTRACT_DOWNLOAD_MODAL_OPEN_ELEMENT_NAME = 'Contracts Download Modal Open';
export const CONTRACT_DOWNLOAD_MODAL_CANCEL_DESC = "Contracts - Download Contract Modal - 'Cancel' Click";
export const CONTRACT_DOWNLOAD_MODAL_CANCEL_ELEMENT_NAME = 'Contracts Download Modal Close';

export const ORDERS_EVENT = 'sendOrdersAnalytics';
export const FILTER_APPLIED_EVENT = 'Filters Applied';
export const ORDERS_HISTORY_APPLY_FILTER_DESC = 'Orders - Filter Interaction';
export const ORDERS_HISTORY_DETAILS_DESC = 'Orders - Order History - Order Details';
export const ORDERS_DOWNLOAD_REPORT_DESC = 'Orders - Order History - Download - Download Modal - Download Button';
export const ORDERS_SALES_REPORT = 'Orders - Sales Report';
export const ORDERS_DOWNLOAD_EVENT = 'Document Download';
export const ORDERS_DOWNLOAD_URL = 'mycargill:food:orders:order history';
export const ORDERS_HISTORY_DOWNLOAD_COA_DESC = 'Orders-Order Histroy- Download COA';
export const ORDERS_HISTORY_DOWNLOAD_PACKING_LIST_DESC = 'Orders-Order Histroy- Download Packing List';
export const ORDERS_HISTORY_DOWNLOAD_INVOICE_DESC = 'Orders-Order Histroy- Download Invoice';
export const ORDERS_HISTORY_DOWNLOAD_BOLETO_DESC = 'Brazil Portal: Order History - Boleto - Download';
export const ORDERS_HISTORY_DOWNLOAD_NOTAFISCAL_DESC = 'Brazil Portal: Order History - Nota Fiscal - Download';

export const ORDERS_HISTORY_COA_MODAL_OPEN_DESC = 'Orders-Order Histroy- Download COA Modal - Click';
export const ORDERS_HISTORY_COA_MODAL_OPEN_ELEMENT_NAME = 'COA Download Modal Open';
export const ORDERS_HISTORY_COA_MODAL_DONE_DESC = "Orders-Order Histroy- Download COA Modal - 'Done' Click";
export const ORDERS_HISTORY_COA_MODAL_DONE_ELEMENT_NAME = 'COA Download Modal Close';
export const ORDERS_HISTORY_COA_MODAL_REQUEST_COA_CLICK =
  'Orders-Order History - Request COA Modal - Request COA Click';
export const ORDERS_HISTORY_COA_MODAL_REQUEST_COA_CANCEL =
  'Orders-Order History - Request COA Modal - Request COA CANCEL';
export const ORDERS_HISTORY_COA_MODAL_REQUEST_COA_SUBMIT = 'Orders-Order History - Request COA Modal - Submit Click';
export const ORDERS_HISTORY_COA_MODAL_REQUEST_COA_ERROR = 'Orders-Order History - Request COA - Error';
export const ORDERS_HISTORY_COA_MODAL_REQUEST_COA = 'Orders-Order History - Request COA Modal';
export const ORDERS_REQUEST_COA = 'mycargill:food:orders:order history';
export const REQUEST_COA = 'Request a COA';

export const ORDERS_HISTORY_INVOICE_MODAL_OPEN_DESC = 'Orders-Order History- Download Invoice Modal - Click';
export const ORDERS_HISTORY_INVOICE_MODAL_OPEN_ELEMENT_NAME = 'Invoice Download Modal Open';
export const ORDERS_HISTORY_INVOICE_MODAL_DONE_DESC = "Orders-Order History- Download Invoice Modal - 'Done' Click";
export const ORDERS_HISTORY_INVOICE_MODAL_DONE_ELEMENT_NAME = 'Invoice Download Modal Close';

export const ORDERS_HISTORY_BOLETO_MODAL_OPEN_DESC = 'Orders-Order Histroy- Download Boleto Modal - Click';
export const ORDERS_HISTORY_BOLETO_MODAL_OPEN_ELEMENT_NAME = 'Boleto Download Modal Open';
export const ORDERS_HISTORY_BOLETO_MODAL_DONE_DESC = "Orders-Order Histroy- Download Boleto Modal - 'Done' Click";
export const ORDERS_HISTORY_BOLETO_MODAL_DONE_ELEMENT_NAME = 'Boleto Download Modal Close';

export const ORDERS_HISTORY_NOTAFISCAL_MODAL_OPEN_DESC = 'Orders-Order Histroy- Download Nota Fiscal Modal - Click';
export const ORDERS_HISTORY_NOTAFISCAL_MODAL_OPEN_ELEMENT_NAME = 'Nota Fiscal Download Modal Open';
export const ORDERS_HISTORY_NOTAFISCAL_MODAL_DONE_DESC =
  "Orders-Order Histroy- Download Nota Fiscal Modal - 'Done' Click";
export const ORDERS_HISTORY_NOTAFISCAL_MODAL_DONE_ELEMENT_NAME = 'Nota Fiscal Download Modal Close';

export const ORDERS_PLACE_ADD_TO_CART_EVENT = 'Add to Cart';
export const ORDERS_PLACE_ADD_TO_CART_DESC = 'Orders - Place Order - Add Items to Cart';
export const ORDERS_PLACE_UPDATE_TO_CART_DESC = 'Orders - Place Order - Update Cart';
export const ORDERS_PLACE_ADD_TO_CART_PAGE_NAME = 'mycargill:food:orders:place order:add items to cart';
export const ORDER_CONFIRMATION = 'Order Confirmation';

export const ORDERS_REMOVE_ITEM_FROM_CART_DESCP = 'Orders - Place Order - Remove Cart';
export const ORDERS_REMOVE_ITEM_FROM_CART_EVENT = 'Remove From Cart';

export const ORDERS_APPLY_FILTER_DESC = 'Orders - Place Order - Filter Interaction';

export const CART_DESC = 'Orders - Place Order - Your Cart';

export const REQUEST_SAMPLE = 'sendRequestSampleAnalytics';
export const REQUEST_SAMPLE_START_EVENT = 'Process Start';
export const REQUEST_SAMPLE_CAPABILITY = 'Sample';
export const REQUEST_SAMPLE_COMPLETE_EVENT = 'Process Complete';
export const REQUEST_SAMPLE_SATRT_DESC = 'Products - Request a Sample - Select Products';
export const REQUEST_SAMPLE_COMPLETE_DESC = 'Products - Request a Sample - Request Successfully Submitted';
export const REQUEST_SAMPLE_START_PAGE_NAME = ':products:request a sample:select products';
export const REQUEST_SAMPLE_COMPLETE_PAGE_NAME = ':products:request a sample:sample request complete';
export const REQUEST_SAMPLE_ERROR_PAGE_NAME = ':products:request a sample:sample request error';
export const REQUEST_SAMPLE_ERROR_DESC = 'Products - Request a Sample - Request Failed';
export const REQUEST_SAMPLE_ERROR_EVENT = 'Process Error';
export const REQUEST_SAMPLE_ELEMENT_NAME = "Can't Find Product";
export const REQUEST_SAMPLE_CAN_FIND_PRODUCT_PAGE_NAME =
  "mycargill:food:products:request a sample: select products can't find product";
export const REQUEST_SAMPLE_CAN_FIND_PRODUCT_DESCRIPTION = "Request a Sample: Select products: can't find product";

export const DEFAULT_PATH = 'mycargill:food';

export const REQUEST_QUOTE_EVENT = 'sendQuoteAnalytics';
export const REQUEST_QUOTE_START_EVENT = 'Process Start';
export const REQUEST_QUOTE_COMPLETE_EVENT = 'Process Complete';
export const REQUEST_QUOTE_ERROR_EVENT = 'Quote Process Error';
export const REQUEST_QUOTE_START = 'Products - Request a Quote - Select Products';
export const REQUEST_QUOTE_COMPLETE = 'Products - Request a Quote - Request Successfully Submitted';
export const REQUEST_QUOTE_ERROR = 'Products - Request a Quote - Request Not Successfully Submitted';
export const REQUEST_QUOTE_CAPABILITY = 'Request Quote';
export const REQUEST_QUOTE_PAGE_NAME = ':products:request a quote:select products';
export const REQUEST_QUOTE_SUBMITTED_PAGE_NAME = ':products:request a quote:quote request complete';

export const CATALOG_EVENT = 'sendCatalogAnalytics';
export const CATALOG_PLP_FILTER_DESCRIPTION = 'Products - View Products - Filter Interaction';
export const CATALOG_ALL_PRODUCTS_TAB_DESCRIPTION = 'Catalog All Products Tab';
export const CATALOG_CURRENTLY_BUYING_TAB_DESCRIPTION = 'Catalog Currently Buying Tab';
export const CATALOG_ALL_PRODUCTS_TAB = 'All Products Tab';
export const CATALOG_CURRENTLY_BUYING_TAB = 'Currently Buying Tab';
export const CATALOG_PDP_VIEW_PRODUCT_DESCRIPTION = 'Products - View Product Description';
export const CATALOG_PDP_TAB_PRODUCT_DETAIL_DESCRIPTION = 'Products - View Product Details';
export const CATALOG_TAB_NUTRITIONAL_INFO_DESCRIPTION = 'Products - Nutritional Information';
export const CATALOG_TAB_DOCUMENTS_DESCRIPTION = 'Products - Documents';
export const CATALOG_PDP_DOCUMENT_DOWNLOAD_DESCRIPTION = 'Product - Technical Document/Product Document';
export const CATALOG_DOWNLOAD_EVENT = 'Document Download';
export const CATALOG_PROD_DESCP_URL = 'productdescription';
export const CATALOG_PROD_DETAIL_URL = 'productdetail';
export const CATALOG_NUTRI_INFO_URL = 'productnutritionalinformation';
export const CATALOG_DOCS_URL = 'productdocuments';
export const CATALOG_PROD_DESCPTION_URL = ':products:##:product description';
export const CATALOG_PROD_DETAILS_URL = ':products:##:product details';
export const CATALOG_NUTRITIONAL_INFO_URL = ':products:##:nutritional info';
export const CATALOG_DOCUMENTS_URL = ':products:##:documents';

export const DOCUMENTS_EVENT = 'sendDocumentsAnalytics';
export const DOCUMENTS_PREVIEW_EVENT = 'Document View';
export const DOCUMENTS_PREVIEW_DOCUMENT_DESCP = 'Documents - Preview Document';
export const DOCUMENTS_DOWNLOAD_DOCUMENT = 'Documents - Download Document';
export const DOCUMENTS_DOWNLOAD_EVENT = 'Document Download';
export const DOCUMENTS_ADDED_TO_FAVORITES_DESCP = 'Documents - Technical Documents - Add to Favorites';
export const DOCUMENTS_REMOVED_TO_FAVORITES_DESCP = 'Documents - Technical Documents - Remove Favorites';
export const DOCUMENTS_ADDED_TO_FAVORITES_ELEMENT_NAME = 'Add Document to Favorites';
export const DOCUMENTS_REMOVED_TO_FAVORITES_ELEMENT_NAME = 'Remove Document from Favorites';
export const DOCUMENTS_TOGGLE_FAVORITES_EVENT = 'Click Action';
export const DOCUMENTS_TAB_ELEMENT_CATEGORY = '{**}: {##}';
export const TECH_DOCS = 'Tech Docs';
export const PROD_DOCS = 'Prod Docs';
export const DOCUMENTS_RESULTS = 'Results';
export const DOCUMENTS_FAVORITES = 'Favorites';
export const DOCUMENTS_MY_PRODUCTS = 'Contracted Products';
export const DOCUMENTS_TAB_DESCP = 'Documents - Technical Documents - {##}';
export const DOCUMENTS_TAB_ELEMENT_NAME = '{##} Tab';
export const DOCUMENTS_CLICK_ACTION = 'Click Action';
export const DOCUMENTS_PAGELOADED_EVENT = 'Page Loaded';
export const DOCUMENTS_FAVORITES_URL = 'mycargill:food:documents:favorites';
export const DOCUMENTS_MY_PRODUCTS_URL = 'mycargill:food:documents:technical:contracted products';
export const DOCUMENTS_FILTERS_DESCP = 'Documents - Filter Interaction';
export const DOCUMENTS_FILTERS_EVENT = 'Filters Applied';
export const DOCUMENTS_PREVIEW_URL = 'mycargill:food:documents:view document details';
export const DOCUMENTS_BOOKMARK_ACTION_URL = 'myCargill:food:documents';
export const DOCUMENTS_PRODUCT_PAGELOAD_DESCP = 'Documents - Product Documents';
export const DOCUMENTS_TECHNICAL_PAGELOAD_DESCP = 'Documents - Technical Documents';
export const MORE_ON_THIS_SITE_EXPAND_DESCP = 'Documents - Technical Documents - More On This Site - Expand';
export const MORE_ON_THIS_SITE_COLLAPSE_DESCP = 'Documents - Technical Documents - More On This Site - Collapse';
export const MORE_ON_THIS_SITE_EVENT = 'Click Action';
export const MORE_ON_THIS_SITE_ELEMENT_CATEGORY = 'Tech Docs: More On This Site';
export const MORE_ON_THIS_SITE_ELEMENT_NAME_EXPAND = 'Expand - More On This Site';
export const MORE_ON_THIS_SITE_ELEMENT_NAME_COLLAPSE = 'Collapse - More On This Site';
export const EXTERNAL_LINK_EVENT = 'External Link Click';
export const INTERNAL_LINK_EVENT = 'Internal Link Click';
export const LINK_DESCP = 'Documents - Technical Documents - More On This Site';
export const LINK_ELEMENT_CATEGORY = 'Tech Docs: More On This Site';
export const RELATED_DOCS_OPEN_DESCP = 'Documents - Technical Documents - Show Related Documents Modal';
export const RELATED_DOCS_OPEN_ELEMENT_NAME = 'Show - Related Documents';
export const RELATED_DOCS_ACTION = 'Click Action';
export const RELATED_DOCS_ELEMENT_CATEGORY = 'Tech Docs: Related Documents';
export const RELATED_DOCS_CLOSE_DESCP = 'Documents - Technical Documents - Close Related Documents Modal';
export const RELATED_DOCS_CLOSE_ELEMENT_NAME = 'Close - Related Documents';
export const RELATED_DOCS_CLEAR_ALL_DESCP = 'Documents - Technical Documents - Related Documents - Clear All';
export const RELATED_DOCS_CLEAR_ALL_ELEMENT_NAME = 'Clear All - Related Documents';
export const RELATED_DOCS_FAVORITES_DESCP = 'Documents - Technical Documents - Related Documents - Add to Favorites';
export const RELATED_DOCS_REMOVED_FAVORITES_DESCP =
  'Documents - Technical Documents - Related Documents - Remove Favorites';
export const RELATED_DOCS_FAVORITES_ELEMENT_NAME = 'Add Document to Favorites';
export const RELATED_DOCS_REMOVED_FAVORITES_ELEMENT_NAME = 'Remove Document from Favorites';
export const RELATED_DOCS_DOWNLOAD_DESCP = 'Documents - Technical Documents - Related Documents - Document Download';
export const RELATED_DOCS_DOWNLOAD_EVENT = 'Document Download';

export const REQUEST_TECH_DOC_CAPABILITY = 'Request Technical Document';
export const REQUEST_TECH_DOC_START_EVENT = 'Process Start';
export const REQUEST_TECH_DOC_START_EVENT_URL = 'mycargill:food:documents:request technical document:start';
export const REQUEST_TECH_DOC_COMPLETE_EVENT_URL = 'mycargill:food:documents:request technical document:complete';
export const REQUEST_TECH_DOC_UPLOAD_EVENT_URL = 'mycargill:food:documents:request technical document:upload document';
export const REQUEST_TECH_DOC_DESCP = 'Request a Technical Document';
export const REQUEST_TECH_DOC_COMPLETE_EVENT = 'Process Complete';
export const REQUEST_TECH_DOC_UPLOAD_COMPLETE_DESCP = 'Upload a Document';
export const REQUEST_TECH_DOC_UPLOAD_COMPLETE_EVENT = 'Document Upload';
export const REQUEST_TECH_DOC_UPLOAD_FAILED_DESC = 'Request a Technical Document - Request Failed';
export const REQUEST_TECH_DOC_UPLOAD_FAILED_EVENT = 'Process Error';
export const REQUEST_TECH_DOC_UPLOAD_FAILED_URL = 'mycargill:food:documents:request technical document:error';

export const NOTIFICATIONS_PREFERENCES_ANALYTICS = 'sendNotificationPreferencesAnalytics';
export const NOTIFICATIONS_CAPABILITY = 'Notifications';
export const NOTIFICATIONS_PAGE_NAME = 'mycargill:food:notifications';
export const NOTIFICATIONS_CLICK_ACTION_EVENT = 'Click Action';

export const NOTIFICATIONS_PREFERENCES_DESCP_ACTIVE =
  'Notifications - Preferences - Enable Notifications Toggle - Active';
export const NOTIFICATIONS_PREFERENCES_DESCP_DEACTIVATED =
  'Notifications - Preferences - Enable Notifications Toggle - Deactivated';
export const NOTIFICATIONS_PREFERENCES_ENABLE_NOTIFICATIONS_ELMT_ACTIVE = 'Enable Notifications Active';
export const NOTIFICATIONS_PREFERENCES_ENABLE_NOTIFICATIONS_ELMT_DEACTIVATED = 'Enable Notifications Deactivated';
export const NOTIFICATION_PREFERENCES_CONTRACTS_DESCP_ACTIVE =
  'Notifications - Preferences - Monthly Contract Email Toggle - Active';
export const NOTIFICATION_PREFERENCES_ORDERS_DESCP_ACTIVE =
  'Notifications Preferences - Order Tracking Status Notification Toggle - Active';
export const NOTIFICATION_PREFERENCES_CONTRACTS_DESCP_DEACTIVE =
  'Notifications - Preferences - Monthly Contract Email Toggle - Deactivated';
export const NOTIFICATION_PREFERENCES_ORDERS_DESCP_DEACTIVE =
  'Notifications Preferences - Order Tracking Status Notification Toggle - Deactivated';
export const NOTIFICATION_PREFERENCES_DOCUMENT_DESCP_ACTIVE =
  'Notifications Preferences - Bookmarked Document Status Notification Toggle - Active';
export const NOTIFICATION_PREFERENCES_DOCUMENT_DESCP_DEACTIVE =
  'Notifications Preferences - Bookmarked Document Status Notification Toggle - Deactivated';
export const NOTIFICATION_PREFERENCES_CONTRACTS_ELMT_ACTIVE = 'Monthly Contract Email Notifications Active';
export const NOTIFICATION_PREFERENCES_ORDERS_ELMT_ACTIVE = 'Order Tracking Status Notifications Active';
export const NOTIFICATION_PREFERENCES_CONTRACTS_ELMT_DEACTIVE = 'Monthly Contract Email Notifications Deactivated';
export const NOTIFICATION_PREFERENCES_ORDERS_ELMT_DEACTIVE = 'Order Tracking Status Notifications Deactivated';
export const NOTIFICATION_PREFERENCES_DOCUMENT_ELMT_ACTIVE = 'Bookmarked Document Status Notifications Active';
export const NOTIFICATION_PREFERENCES_DOCUMENT_ELMT_DEACTIVE = 'Bookmarked Document Status Notifications Deactivated';

export const GLOBAL_NOTIFICATIONS_ANALYTICS = 'sendGlobalNotificationsAnalytics';
export const GLOBAL_NOTIFICATIONS_CLEAR_ALL_DESCP = 'Notifications - Clear all button';
export const GLOBAL_NOTIFICATIONS_CLEAR_ALL_ELEMENT = 'Clear All Notifications';

export const GLOBAL_NOTIFICATIONS_DISMISS_DESCP = 'User opt-out of a notification';
export const GLOBAL_NOTIFICATIONS_DISMISS_EVENT = 'Notification Dismissed';

export const GLOBAL_NOTIFICATIONS_READ_DESCP = 'User opt-in on a notification';
export const GLOBAL_NOTIFICATIONS_READ_EVENT = 'Notification Click';

export const GLOBAL_NOTIFICATIONS_OPEN_DESCP = 'User open the Notifications Icon';
export const GLOBAL_NOTIFICATIONS_OPEN_EVENT = 'Notification View';

export const MEXICO = 'mx';
export const BRAZIL = 'br';

// Default Languages
export const SPANISH = 'es';

export const BASED_URL_KEY = 'baseUrlSet';

// for CTA Purpose

export const CURRENT_ACCOUNT = 'currentAccount';
export const ACCOUNT = 'account';
export const REGION = 'region';

export const MY_REQUESTS_ANALYTICS = 'myRequests';
export const MY_REQUESTS_CAPABILITY = 'Customer Request Center';
export const MY_REQUESTS_CLICK_ACTION = 'Click Action';
export const MY_REQUESTS_PROCESS_ERROR = 'Process Error';
export const MY_REQUESTS_PROCESS_COMPLETE = 'Process Complete';
export const MY_REQUESTS_DOCUMENT_UPLOAD = 'Document Upload';
export const MY_REQUESTS_PROCESS_START = 'Process Start';
export const MY_REQUESTS_PAGE_LOADED = 'Page Loaded';
export const MY_REQUESTS_TAB_CLOSED_DESCP = 'Tech Docs tab - Closed Page Load';
export const MY_REQUESTS_TAB_OPEN_DESCP = 'Tech Docs tab - Open Page Load';
export const MY_REQUESTS_URL = 'mycargill:food:customer request center:tech docs:{#}';
export const OPEN_REQUESTS = 'open requests';
export const CLOSED_REQUESTS = 'closed requests';
export const MY_REQUESTS_SUPPORT_DESCP = 'Tech Docs: Single Request - Ask a Question (?) button';
export const MY_REQUESTS_SUPPORT_URL = 'mycargill:food:customer request center:tech docs:{##}';
export const MY_REQUESTS_PROCESS_NAME = 'Document Request Contact Form';
export const MY_REQUESTS_SUPPORT_ELEMENT_GROUP = 'Tech Docs: Ask a Question';
export const MY_REQUESTS_SUPPORT_PROCESS_COMPLETE_DESCP =
  'Technical Documents > {##} > Contact Us Complete (Ok Button)';
export const MY_REQUESTS_SUPPORT_PROCESS_ERROR_DESCP = 'Tech Docs: Single Request -  Ask a Question form error';
export const MY_REQUESTS_REQ_TECH_DOC_DESCP = 'Tech Docs: Request a Technical Document';
export const MY_REQUESTS_REQ_TECH_BASE_URL = 'mycargill:food:customer request center:tech docs:{##}';
export const MY_REQUESTS_REQ_TECH_DOCUMENT_UPLOAD_DESCP = 'Tech Docs: Upload a Document';
export const MY_REQUESTS_REQ_TECH_PROCESS_ERROR_DESCP = 'Request a Technical Document - Request Failed';
export const MY_REQUESTS_REQ_TECH_ELEMENT_GROUP = 'Tech Docs: Request a Technical Document';
export const MY_REQUESTS_CONTACT_US_DESCP = 'Technical Documents > {##} > Contact Us btn click - Start';
export const MY_REQUESTS_FORM_SUBMIT_DESCP = 'Technical Documents > {##} > Confirmation request Submit';
export const MY_REQUESTS_FOLLOW_UP_ERROR = 'Technical Documents > {##} > Error - Message not submitted';
export const MY_REQUESTS_FORM_SUBMIT_EVENT = 'Submit';
export const MY_REQUESTS_FORM_CANCEL_DESCP = 'Technical Documents > {##} > Confirmation request Cancel';
export const MY_REQUESTS_FORM_CANCEL_EVENT = 'Cancel';
export const MY_REQUESTS_OPEN_TAB = 'Open Reqs';
export const MY_REQUESTS_CLOSED_TAB = 'Closed Reqs';

// Reorder
export const REORDER_ANALYTICS = 'Reorder';

// Maintenance
export const MAINTENANCE_CAPABILITY = 'Site Maintenance';
export const MAINTENANCE_CATEGORY = 'Customer Portal';
export const MAINTENANCE_PRODUCT = 'Food';
export const MAINTENANCE_DESCRIPTION = 'Site Maintenance Page Display';
export const MAINTENANCE_EVENT = 'Page Loaded';
export const MAINTENANCE_PAGE_NAME = 'mycargill:food:site maintenance page';

// Numbers and common strings
export const CCCNA_SALES_AREAS = ['1015-01-10', '1015|01|10'];
export const KG = 'KG';
export const LB = 'LB';
export const CONVERSION_UNIT_TO_LB = 2.2046226218;
